export default () => {
  window.recaptchaSuccess = function (response, event) {
    if (!response.success || response.score < 0.6) return;

    if (event) {
      event.target.submit();
    }
  };

  window.recaptchaFailure = function (response, event) {
    console.error(
      "We could not verify the user with Google reCaptcha 3: " +
        response["error-codes"].join(",")
    );
  };
};
